export const PAGES_WITH_STICKY_HEADER = [
    'category',
    'searchResults',
    'home',
    'addReview',
    'productEdit',
];
